import styles from './Footer.module.css';

/* 개인정보처리방침 URL — 확정 시 변경하세요 */
const PRIVACY_URL = '#';

function Footer({ onConsentClick }) {
  return (
    <footer className={styles.footer}>
      <p className={styles.corpName}>(주)에이지웰</p>
      <p className={styles.privacyPolicy}>
        <a href={PRIVACY_URL} className={styles.privacyLink}>개인정보처리방침</a>
      </p>
      <button type="button" className={styles.personalInfoFormBtn} onClick={onConsentClick}>
        개인정보수집 및 이용동의
      </button>
    </footer>
  );
}

export default Footer;
